import { InjectionKey } from "vue";
import { ObjetoPadrao } from "./objetopadrao";

export const FormValidatedValuesKey: InjectionKey<ObjetoPadrao> = Symbol(
  "FormValidatedValuesKey"
);
export const FormValidatedErrorsKey: InjectionKey<Record<string, string>> =
  Symbol("FormValidatedErrorsKey");

export type FormValidatedUpdateFn = (values: ObjetoPadrao) => void;

export const FormValidatedUpdateKey: InjectionKey<FormValidatedUpdateFn> =
  Symbol("FormValidatedUpdateKey");
